<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { CrossIcon } from '$global/assets/icons/CrossIcon';

	interface Props {
		color?: string;
		class?: string;
		onclick?: (e: Event) => void;
	}

	let { ...props }: Props = $props();
</script>

<button
	class={classNames('absolute right-1 p-[0.1875rem]')}
	onclick={props.onclick}
>
	<CrossIcon color={props.color} class={twMerge('h-3 w-3', props.class)} />
</button>
